import * as React from 'react';
import { Table, CustomButton, ButtonType } from "soprasteria-ui-library";
import { ITreatmentReportTreatment } from '../../../models/ITreatmentReport';
import { dateTimeToDateString } from '../../../helpers/DateHelper';

interface ITreatmentsTable {
    registeredTreatments: ITreatmentReportTreatment[];
    onDelete?: (treatmentId: number) => void;
}

export const TreatmentsTable: React.FunctionComponent<ITreatmentsTable> = ({ registeredTreatments, onDelete }) => {
    const removeTreatment = (patientTreatmentId: number) => {
        const removeTreatment = window.confirm("Är du säker på att du vill ta bort den här åtgärdskoden?");
        if (removeTreatment) {
            if (onDelete) {
                onDelete(patientTreatmentId);
            }
        }
    }

    return (
        <Table>
            <thead>
                <tr>
                    <th>Kod</th>
                    <th>Beskrivning</th>
                    <th>Antal</th>
                    <th>Behandlingsdatum</th>
                    <th>Behandlare</th>
                    {
                        onDelete ?
                            <th className="delete-btn">Ta bort</th>
                            : null
                    }
                </tr>
            </thead>
            <tbody>
                {
                    registeredTreatments.length > 0 ?
                        registeredTreatments.map((treatment, key) => {
                            return (
                                <tr key={key} >
                                    <td>{treatment.code}</td>
                                    <td>{treatment.description}</td>
                                    <td>{treatment.quantity}</td>
                                    <td>{dateTimeToDateString(treatment.date)}</td>
                                    <td>{treatment.carePerformer?.carePerformerName}</td>
                                    {
                                        onDelete ?
                                            <td className="delete-btn">
                                                <CustomButton buttonType={ButtonType.delete} onClick={() => removeTreatment(treatment.patientTreatmentId ?? 0)} buttonText="" />
                                            </td>
                                            : null
                                    }
                                </tr>
                            )
                        })

                        : <tr><td colSpan={onDelete ? 6 : 4}>Det finns inga åtgärdskoder rapporterade</td></tr>
                }
            </tbody>
        </Table>
    )
}